module.exports = __webpack_public_path__ + "static/media/ellipsoid.a7db311c.png";